import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useLanguage } from "../../../../Translations/LenguageContext";
import ErrorMessage from "../../../../Components/ErrorMessage";
import Spinner from "../../../../Components/Spinner";

const NewUserModal = ({ show, handleClose, fetchRecords }) => {
    const { t } = useLanguage();
    const user_id = sessionStorage.getItem("user_id");
    const { project_id, db_id } = useParams();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({ message: "", display: false });
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [role, setRole] = useState("read");

    const CloseModal = () => {
        handleClose();
        setError({ message: "", display: false });
        setUsername("");
        setPassword("");
        setRole("read");
    };

    const handleSaveUser = async () => {
        if (!username || !password) {
            setError({ message: "Username and password are required", display: true });
            return;
        }

        const passwordError = validatePassword(password, username);
        if (passwordError) {
            setError({ message: passwordError, display: true });
            return;
        }

        setLoading(true);
        setError({ message: "", display: false });

        try {
            let dataToSend = {
                user_id: user_id,
                project_id: project_id,
                db_id: db_id,
                username: username,
                password: password,
                role: role,
            }
            const response = await fetch("https://backend.erioon.com/new_sql_access", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id,
                    project_id,
                    db_id,
                    username,
                    password,
                    role: role,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                setError({ message: data.error || "Failed to create user", display: true });
            } else {
                CloseModal();
                fetchRecords();

            }
        } catch (err) {
            setError({ message: err.message || "Network error", display: true });
        } finally {
            setLoading(false);
        }
    };

    const validatePassword = (password, username) => {
        if (password.length < 8 || password.length > 128) return "Password must be between 8 and 128 characters long";
        if (/\s/.test(password)) return "Password cannot contain spaces";
        if (username && password.toLowerCase().includes(username.toLowerCase())) return "Password cannot contain the username";

        let categories = 0;
        if (/[a-z]/.test(password)) categories++;
        if (/[A-Z]/.test(password)) categories++;
        if (/\d/.test(password)) categories++;
        if (/[^a-zA-Z0-9]/.test(password)) categories++;

        if (categories < 3) return "Password must contain at least 3 of the following: uppercase, lowercase, number, special character";
        return null;
    };

    return (
        <Modal show={show} onHide={CloseModal} className="modal_share">
            <div className="share_main_cont_modal">
                <p className="share_label">Create user access</p>
                <p className="share_label_desc">Set up a user account with permissions for this database.</p>
                <div className="warning_delete_message">
                    <p>
                        This access credentials grant access to the SQL database. For more details, refer to the{" "}
                        <span onClick={() => window.open("/docs/errors-and-bugs", "_blank")}>{t.docu_link}</span>.
                    </p>
                    <p><strong><i className="fa-solid fa-warning"></i> Keep it secure and share it only with trusted users.</strong></p>
                </div>
                <input
                    className="api_name_input"
                    placeholder="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />
                <input
                    type="password"
                    className="api_name_input"
                    placeholder="Password"
                    value={password}
                    autoComplete="new-password"
                    onChange={(e) => setPassword(e.target.value)}
                />
                <div className="read_write_admin_cont">
                    <button
                        className={role === "read" ? "active" : ""}
                        onClick={() => setRole("read")}
                    >Only read</button>
                    <button
                        className={role === "write" ? "active" : ""}
                        onClick={() => setRole("write")}
                    >Only Write</button>
                    <button
                        className={role === "admin" ? "active" : ""}
                        onClick={() => setRole("admin")}
                    >Admin</button>
                </div>
            </div>
            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button
                        className="save_btn"
                        onClick={handleSaveUser}
                        disabled={loading || !username.trim() || !password.trim()}
                    >
                        {loading ? <Spinner loading={loading} /> : `${t.save} user`}
                    </button>
                    <button className="cancel_btn" onClick={CloseModal}>
                        {t.cancel}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default NewUserModal;
